// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkbox-tags[data-v-34f78b3c]{overflow:hidden}.checkbox-tags .classify .title[data-v-34f78b3c]{font-size:16px;line-height:1em;padding:10px 0;border-bottom:1px solid #f0f0f0;color:#666}.checkbox-tags .classify .children[data-v-34f78b3c]{overflow:hidden;padding-top:24px;margin-right:-20px}.checkbox-tags .classify .children .tag-item[data-v-34f78b3c]{float:left;margin-right:20px;margin-bottom:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
